import { ProjectionStage } from '../components/ProjectionStage';
import { comicSrc } from '../components/ComicBoard';
import { remainingNow, useSession, useTicker } from '../lib/socket';
import { useGameSounds } from '../lib/useGameSounds';

/**
 * The live projection (R-3): the hub's authoritative state on the beamer.
 *
 * The stage itself lives in ProjectionStage, which the playback mode
 * (`#/play`) renders too — this view only supplies the live wiring: the
 * WebSocket state, the interpolated clocks and the stage sound.
 */
export function ProjectionView({ pin }: { pin: string }) {
  const session = useSession(pin, 'projection', {});
  const now = useTicker(200);
  const sound = useGameSounds(session.state, 'projection');

  if (session.fatalError) {
    return (
      <div className="fullmsg fullmsg--beam">
        <h1>Schreibarena</h1>
        <p>{session.fatalError}</p>
      </div>
    );
  }
  if (!session.state) {
    return (
      <div className="fullmsg fullmsg--beam">
        <h1>Schreibarena</h1>
        <p>Verbinden…</p>
      </div>
    );
  }

  const state = session.state;
  return (
    <ProjectionStage
      state={state}
      now={now}
      clockOffset={session.clockOffset}
      remainingMs={(seat) => remainingNow(state, session.stateReceivedAt, now, seat)}
      comicSrc={(comicId) => comicSrc(pin, comicId)}
      onSlide={sound.slide}
      soundUnlock={sound.locked && sound.enabled ? sound.unlock : null}
    />
  );
}
